import React, { useContext, useEffect, useState } from 'react'
import { PanelDeControlContext } from '../../../context/PanelDeControlContext';
import apiAsistentes from '../../../services/apis/apiAsistentes'
import apiEventos from '../../../services/apis/apiEventos';
import { types } from '../../../types/types';
import DeleteIcon from '../../ui/DeleteIcon';
import DeleteIconTimes from '../../ui/DeleteIconTimes';
import EditIcon from '../../ui/EditIcon';
import ListaAsistentes from './ListaAsistentes';
import MenuEditarEvento from './MenuEditarEvento';
import SubirConstancia from './SubirConstancia';
import SubirListaDeAsistentes from './SubirListaDeAsistentes';

import style from './style.module.css'

const EventoSeleccionado = () => {

    
    const [menuEdicionAbierto, setMenuEdicionAbierto] = useState(false)
    const { eventoSeleccionado: evento, setEventoSeleccionado, dispatchEventos } = useContext( PanelDeControlContext );
    const [ idEventoSeleccionado, setIdEventoSeleccionado ] = useState( null );
        
    const [ asistentes, setAsistentes ] = useState( null ); 
    const [ desplegarVistaAsistentes, setDesplegarVistaAsistentes ] = useState( false );
    
    const [ mensaje, setMensaje ] = useState();
    
    useEffect(() => {
        if( evento._id === idEventoSeleccionado) { return }
        setIdEventoSeleccionado( evento._id );
        setDesplegarVistaAsistentes( false );
        setMensaje(null);
    },[ evento, idEventoSeleccionado ]);

    const alternarMenuEdicion = async() => {
        setMenuEdicionAbierto( !menuEdicionAbierto );
    };
    
    const obtenerListaDeAsistentes = async() => {
        if( asistentes ) { return setDesplegarVistaAsistentes( true ) }
        const response = await apiAsistentes.getAll({ params: { id_evento: evento._id} });
        if ( response.response.error ) { return }
        setAsistentes( response.response.data.asistentes )
        setDesplegarVistaAsistentes(true)
    }

    const eliminarListaDeAsistentes = async() => {
        const response = await apiAsistentes.deleteMany( evento._id )
        if( response.response.error ){ return console.log(response.response.errorMsg)}
        dispatchEventos({ type: types.eventoEditado, payload: {...evento, asistentes: null }})
        setEventoSeleccionado({...evento, asistentes: null })
        setMensaje('Lista eliminada')
    }

    const eliminarEvento = async() => {

        // Eliminar de base de datos
        const response = await apiEventos.delete( evento._id )
        if( response.response.error ){ return console.log(response.response.errorMsg )}

        // Eliminar de la vista
        dispatchEventos({type: types.eventoEliminado, payload: evento._id})
        setEventoSeleccionado( null )

    }

    const listaAgregada = (respuesta) => {
        setMensaje(respuesta.msg)
        dispatchEventos({ type: types.eventoEditado, payload: { ...evento, asistentes: respuesta.asistentesAgregados }})
        setEventoSeleccionado({...evento, asistentes: respuesta.asistentesAgregados})
    }
    
    const constanciaAgregada = ( respuesta ) => {
        setMensaje(respuesta.msg)
        dispatchEventos({ type: types.eventoEditado, payload: { ...evento, urlConstancia: respuesta.url }})
        setEventoSeleccionado({...evento, urlConstancia: respuesta.url})

    }

    const borrarConstancia = async() => {
        const eventoSinConstancia = { ...evento, urlConstancia: null }
        const response = await apiEventos.put(eventoSinConstancia);
        if (response.response.error) { return }
        dispatchEventos({ type: types.eventoEditado, payload: eventoSinConstancia })
        setEventoSeleccionado( eventoSinConstancia )
    }

    return ( evento && 
    <div className={ style.eventoSeleccionado_info + ' mt-4' }>

        { !menuEdicionAbierto ?

            <div className={ style.nombreEvento }>
                <div className="col-auto">
                    <h4 className={ style.tituloEvento }> { evento.nombre } </h4>
                </div>
                <div className="col">
                    <div className="row g-2">
                        <div className="col-auto">
                            <EditIcon editCallback={() => alternarMenuEdicion()} />
                        </div>
                        <div className="col-auto">
                            <DeleteIcon deleteCallback={eliminarEvento} />
                        </div>
                    </div>
                </div>
                <small className={ style.idEvento }> <strong> id evento: </strong> { evento._id } </small>
        
                <p className={ style.fechaEvento }> <strong> Fecha: </strong> { evento.fecha ? evento.fecha : 'Sin fecha' } </p>

                <hr className='my-2' />

                <div className="row">
                    <div className="col-auto mb-2">
                        <strong> Constancia: </strong> 
                    </div>
                    { evento.urlConstancia
                        ? <div className="col-auto">
                            <div className="row gx-3">
                                <div className="col">
                                    <a href={evento.urlConstancia} target='_blank' rel='noreferrer' >{evento.urlConstancia}</a>
                                </div>
                                <div className="col">
                                    <DeleteIconTimes deleteCallback={ borrarConstancia } />
                                </div>
                            </div>
                        </div>

                        : 'No hay constancia'
                    }
                    
                </div>

                {
                    !evento.urlConstancia && <SubirConstancia onSuccess={ constanciaAgregada } />
                }

                <hr className='mt-3 mb-2' />

                <p className={ style.asistentesEvento + ' mb-2'}> <strong> Total de asistentes: </strong> { evento.asistentes ? evento.asistentes : 'NA' } </p>

                { 
                    !evento.asistentes ?
                    
                    <SubirListaDeAsistentes onSuccess={ listaAgregada } />
                    
                    :
                    
                    <div className="row mb-3">
                        <div className="col-auto">
                            <button 
                                onClick={ desplegarVistaAsistentes ? () => setDesplegarVistaAsistentes(false) : obtenerListaDeAsistentes } 
                                className={ `btn ${ desplegarVistaAsistentes ? 'btn-secondary' : 'btn-primary' }` }>
                                { desplegarVistaAsistentes ? 'Cerrar lista' : 'Ver lista'}
                            </button>
                        </div>
                        <div className="col-auto">
                            <button 
                                onClick={ eliminarListaDeAsistentes }
                                className="btn btn-danger">
                                Eliminar lista de asistentes
                            </button>
                        </div>
                    </div>
        
        
                }

                <hr className='my-3' />  

                { mensaje &&
                    <div className='mt-3 p-2 bg-primary'>
                        <p> { mensaje } </p>
                    </div>
                }

                { asistentes && desplegarVistaAsistentes &&
                    <ListaAsistentes asistentes={asistentes}/>
                }

            </div>   
            
            : <MenuEditarEvento alternarMenuEdicion={alternarMenuEdicion} />
            
        }

    </div>
    )
}

export default EventoSeleccionado
